import type { SVGProps } from 'react';
const SvgAngleLeft = (props: SVGProps<SVGSVGElement>) => (
  <svg fill="none" viewBox="0 0 24 24" {...props}>
    <path d="M8.22011 11.4689L12.4688 7.22024C12.7624 6.92659 13.2373 6.92659 13.5278 7.22024L14.2339 7.92627C14.5275 8.21993 14.5275 8.69478 14.2339 8.98532L11.2223 11.9969L14.2339 15.0084C14.5275 15.3021 14.5275 15.7769 14.2339 16.0675L13.531 16.7798C13.2373 17.0734 12.7624 17.0734 12.4719 16.7798L8.22324 12.5311C7.92645 12.2374 7.92645 11.7626 8.22011 11.4689V11.4689Z" />
  </svg>
);
export default SvgAngleLeft;
